import ComponentHelper from '../../supers/ComponentHelper';
import React from 'react';
import './dropdown.css';
import Select from 'react-select-plus';

class Dropdown extends ComponentHelper {
	render() {
		let {
			value,
			handleChange,
			autoFocus,
			className,
			label,
			required,
			name,
			placeholder,
			subText,
			disabled,
			options,
			renderValue,
			tagPicker,
			renderOption
		} = this.props;
		return (
			<div className={`dropdown-cmp ${className ? className : ''}`}>
				<label htmlFor={name}>
					<div className={`label ${required ? 'label--required' : ''}`}>{label}</div>
					<Select
						name={name}
						closeOnSelect={!tagPicker}
						className={className}
						value={value}
						multi={tagPicker ? true : false}
						onChange={handleChange}
						options={options}
						disabled={disabled}
						autoFocus={autoFocus}
						valueRenderer={renderValue}
						optionRenderer={renderOption}
						placeholder={placeholder}
					/>
					{subText && <div className="sub-text">{subText}</div>}
				</label>
			</div>
		);
	}
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/dropdown/Dropdown.js